import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { isAuthCall } from '../util/sign-in';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (isAuthCall(req.url, environment.apiBaseUrl)) return next(req);
  const auth = inject(AuthService);
  const token = auth.token();
  return next(token ? req.clone({ setHeaders: { Authorization: 'Bearer ' + token } }) : req).pipe(
    catchError((e: unknown) => {
      if (e instanceof HttpErrorResponse && e.status === 401 && auth.isSignedIn()) {
        auth.expire();
        // Swallowed, not rethrown: the sign-out navigation destroys the page that would have
        // shown the error, and parallel 401s would each surface one. Callers reset their busy
        // flags in `error`, so this relies on that teardown. A 401 that signs nobody out still
        // propagates.
        return EMPTY;
      }
      return throwError(() => e);
    }),
  );
};
